module.exports = __webpack_public_path__ + "img/level_three_lock.ba271835.png";